import $ from 'jquery';
import _ from 'underscore';

/**
 * Features:
 *
 * module can be registered for several pages with names separated by space
 * register('page1 page2 page3', callback);
 * ------------------------------------------------------------------------
 * page name can be a combination of space separated names
 * <body data-page="page1 page2">
 *
 * **/

var bootstraps = {};
var commonBootstraps = [];
var bootstrappingExecuted = false;
var body = $('body');
var modules = body.data('page');

/**
 * Method registers bootstrap method to be executed after all code is loaded
 * @param {String} name
 * @param {Function} bootstrapFunction
 */
export function register(name, bootstrapFunction) {
  if (typeof bootstrapFunction === 'function') {
    if (typeof name === 'string') {
      var names = name.split(/\s+/);

      _.each(names, function(n) {
        /*
                 If bootstrap name is not initialized, initialize
                 */
        if (!bootstraps[n]) {
          bootstraps[n] = [];
        }

        bootstraps[n].push(bootstrapFunction);
      });
    } else if (name === null) {
      commonBootstraps.push(bootstrapFunction);
    }
  }
}

/**
 * Method executes current bootstrap function based on classnames attached to body element
 */
export function run() {
  if (!bootstrappingExecuted) {
    /*
     * Execute common initializers
     */
    _.each(commonBootstraps, function(commonBootstrap) {
      commonBootstrap();
    });

    if (modules) {
      /*
             Iterate over all modules to be initialized
             */
      _.each(
        modules.split(/\s+/),
        function(className) {
          runOne(className);
        },
        this
      );
    }

    bootstrappingExecuted = true;
  }
}

/**
 * Method executes bootstrapper for 'moduleName'
 */
export function runOne(moduleName) {
  var moduleBootstraps = bootstraps[moduleName];

  if (moduleBootstraps) {
    _.each(moduleBootstraps, function(moduleBootstrap) {
      moduleBootstrap();
    });
  }
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/core/bootstrapper.js
 **/